import React from 'react';

export const JobLevelInputTooltip = () => (
  <>
    <strong>Video Processing:</strong> CLIPr just process your video.
    <br />
    <br />
    <strong>Transcript:</strong> CLIPr simply creates a downloadable transcript
    of your video.
    <br />
    <br />
    <strong>AI Enrichment:</strong> CLIPr’s native AI and machine learning will
    create a searchable, actionable index of Topics that your video contains.
    Each moment can be shared via social media, email, or shareable HTML.
    <br />
    <br />
    <strong>Custom Enrichment:</strong> A human editor reviews AI enrichment
    output for accuracy.
  </>
);

export const VideoSpecialtyInputTooltip = () => (
  <>
    <strong>Video Specialty:</strong> When selected, CLIPr applies a specialized
    glossary when indexing your video. In upcoming releases, we plan to add
    glossaries for legal and fiscal terminology.
  </>
);
